import React from 'react';
import { Flex } from 'lib/components/styles/layout';
import { ILandingPageDesignResponse } from '../../../types';
import {
  BodyContainer,
  CtaButton,
  GradientOverlay,
  StyledBackgroundImage,
  VideoPlayerImage,
} from './styles';
import videoPlayerImage from '../../../assets/videoPlayer.png';

interface IBodyProps {
  landingPageDesign: ILandingPageDesignResponse;
}

export const Body = ({ landingPageDesign }: IBodyProps) => {
  const ctaButtonCount = 3;
  const {
    bodyBackgroundColor,
    bodyBackgroundImage,
    buttonFontCase,
    buttonFontWeight,
    buttonFontFamily,
    buttonFontSize,
    buttonCornerRadius,
    buttonPaddingY,
    buttonPaddingX,
    buttonColor,
    buttonBorderColor,
    buttonBorderHoverColor,
    buttonTextColor,
    buttonTextHoverColor,
    showButtonBorder,
    buttonHoverColor,
    showGradient,
    gradient,
  } = landingPageDesign;

  return (
    <BodyContainer
      bodyBackgroundColor={bodyBackgroundColor}
      bodyBackgroundImage={bodyBackgroundImage}
    >
      {bodyBackgroundImage && (
        <StyledBackgroundImage
          src={bodyBackgroundImage}
          alt='background-img-thumbnail-preview'
        />
      )}
      {!!showGradient && <GradientOverlay gradient={gradient} />}
      <Flex
        maxWidth='90px'
        gap={'4px'}
        alignItems='center'
        style={{ zIndex: 1 }}
      >
        <VideoPlayerImage src={videoPlayerImage} />
        <Flex
          justifyContent='center'
          flexDirection='row'
          flexWrap='wrap'
          gap='2px'
          width='100%'
        >
          {Array.from({ length: ctaButtonCount }).map((_, index) => (
            <CtaButton
              key={index}
              buttonFontCase={buttonFontCase}
              buttonFontWeight={buttonFontWeight}
              buttonFontFamily={buttonFontFamily}
              buttonFontSize={buttonFontSize}
              buttonCornerRadius={buttonCornerRadius}
              buttonPaddingY={buttonPaddingY}
              buttonPaddingX={buttonPaddingX}
              buttonColor={buttonColor}
              buttonHoverColor={buttonHoverColor}
              buttonBorderColor={buttonBorderColor}
              buttonBorderHoverColor={buttonBorderHoverColor}
              showButtonBorder={showButtonBorder}
              buttonTextColor={buttonTextColor}
              buttonTextHoverColor={buttonTextHoverColor}
            >
              Button
            </CtaButton>
          ))}
        </Flex>
      </Flex>
    </BodyContainer>
  );
};
